import styled, { css } from 'styled-components';

import BaseCustomIcon from '@components/utils/CustomIcon';
import InfoNoteComponent from '@components/ui/InfoNote';
import { Row as BaseRow } from '@components/Grid';
import FlexContainer from '@components/utils/FlexContainer';

export const HowToTitle = styled.span<{ fontSize?: string }>`
  margin-bottom: 8px;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '24px')};
  letter-spacing: 1px;
  line-height: normal;
  font-weight: 700;
  color: ${(p) => p.theme.palette.D500};
`;
export const HowToStepDescription = styled.span<{
  fontSize?: string;
  lineHeight?: number;
}>`
  font-size: ${({ fontSize }) => (fontSize ? '14px' : '12px')};
  line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : 2.25)};
  letter-spacing: normal;
  color: ${(p) => p.theme.palette.darkGrey};
`;

export const CustomIcon = styled(BaseCustomIcon)`
  position: relative;
  top: 1.5px;
`;

export const Text = styled.span`
  font-weight: 600;
`;
export const ChippinWrapper = styled.div`
  background-color: ${(p) => p.theme.palette.NL20};
  padding: 8px;
  margin-left: 28px;
  border-radius: 8px;
`;

export const Container = styled.div`
  display: flex;
  column-gap: 8px;
`;
export const Separate = styled.div`
  margin-bottom: 10px;
`;
export const InfoText = styled.span`
  font-size: 16px;
  line-height: 1.5;
  color: ${(p) => p.theme.palette.matterHorn};
  & > & {
    font-weight: bold;
  }
`;
export type InfoNoteProps = {
  customCss?: ReturnType<typeof css>;
};
export const InfoNote = styled(InfoNoteComponent)<InfoNoteProps>`
  && {
    ${(p) => p.customCss}
    align-items: center;
    span {
      margin-left: 3px;
      font-size: 12px;
      font-weight: normal;
    }
  }
`;
export const getWarningNote = <T>(price: T) =>
  `Sepet Tutarınız “${price} ₺” dir. Fazla Ödeme yapmaya çalışıyorsunuz. Ödeme Tutarını Düzelterek devam edebilirsiniz.`;

export const Row = styled(BaseRow)`
  padding-right: 120px;
  @media (max-width: 675px) {
    padding-right: 0;
  }
`;
export const priceWarningCss = css`
  padding-top: 11.5px;
  padding-bottom: 11.5px;
`;
export const Col = styled(FlexContainer)`
  & > div {
    max-width: 385px;
  }
  @media screen and (max-width: 675px) {
    padding-right: 0px;
    & > div {
      max-width: 100%;
    }
  }
  & > ${FlexContainer} {
    max-width: 100%;
    &[data-role='wrapper'] {
      gap: 10px;
      flex-wrap: wrap;
      & > div {
        &:first-child {
          max-width: 100%;
          width: 100%;
          @media (min-width: 676px) {
            flex: 1;
            max-width: 385px;
          }
        }
        &:nth-child(2) {
          width: 100%;
          justify-content: start !important;
          @media (min-width: 676px) {
            max-width: 249px;
          }
          svg {
            height: 15px;
            width: 15px;
          }
        }
      }
    }
    &[data-role='confirm-box'] {
      position: relative;
      align-items: center;
      flex-wrap: wrap;
      gap: 20px;
      & > div:first-child {
        max-width: 385px;
        width: 385px;
        @media screen and (max-width: 675px) {
          max-width: 100%;
          width: 100%;
        }
      }
    }
  }
`;
